import { authHeader, handleResponse } from '../helpers';

export const locationMasterService = {
  GetRegionDll,
  getStateDDL,
  addState,
  addDistrict,
  getDistrictDDL,
  addTown,
  getAllLoation
};

function GetRegionDll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetRegion`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch regions");
      }
      return data;
    });
}

function getStateDDL(regionId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetStateRegionWise?regionId=${regionId}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch states");
      }
      return data;
    });
}
function getDistrictDDL(regionId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetDistrictDLL/${regionId}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      if (data.ResponseCode !== "200") {
        throw new Error(data.ResponseMessage || "Failed to fetch states");
      }
      return data;
    });
}

function addState(stateData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(stateData)
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/AddState`, requestOptions)
    .then(handleResponse);
}

function addDistrict(districtData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(districtData)
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/AddDistrict`, requestOptions)
    .then(handleResponse);
}
function addTown(districtData) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(districtData)
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/AddTown`, requestOptions)
    .then(handleResponse);
}
function getAllLoation(requestLocation){
  const requestOptions = {
    method: 'POST',
   headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(requestLocation)
  };

  return fetch(`${process.env.REACT_APP_API_URL}UserDMaster/GetAllLocation`, requestOptions)
    .then(handleResponse);
}